module.exports = __webpack_public_path__ + "img/MD.83abd003.svg";